import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('student');

export class StudentCareer extends Api {
  constructor(http, config = {}) {
    super(http, url, 'student-career', config);
  }

  getStudentDebt(studentCareerId){
    return this.find(`${studentCareerId}/debt`)
  }
}